import { Payment } from "types";

export interface SplitPaymentInitialValues {
    demographics: SplitPayFieldValue[];
    addons: SplitPayFieldValue[];
    taxes: number;
}

export interface SplitPayFieldValue {
    id: ID | undefined;
    quantity: number;
    amount: number;
    name: string;
}

export interface SplitPayFormValues {
    customerName: string;
    customerEmail?: string;
    phone?: string;
    amount: number;
    notify: boolean;
    divideParts: number;
    payParts: number;
    splitPayOption: SplitPayOptions;
    isPayAndAddOption: boolean;
    payment: Payment;
    chargeCard: boolean;
}

export const enum SplitPayOptions {
    REMAINING_BALANCE,
    CUSTOM_AMOUNT,
    DIVIDE_PARTS,
    SELECT_DEMOGRAPHIC_AND_ADDON,
}

export interface SplitPayDemographics {
    items: Array<{ id: string; splitPayItemValues: SplitPaymentInitialValues }>;
}
